{
  "add-a-stream": {
    "button": "Ajouter un flux"
  },
  "add-new-page": {
    "audio-dedications": "Dédicaces Audio",
    "dedications": "Dédicaces",
    "html": "HTML",
    "livefeed": "LiveFeed",
    "podcast": "Podcast",
    "reveil": "Réveil",
    "rss": "RSS",
    "rss-news": "Actualités",
    "rss-podcasts": "Podcast",
    "rss-video": "Vidéo",
    "site": "Website",
    "song-history": "Historique des titres",
    "title": "Ajouter une page"
  },
  "android-screenshot": {
    "desc": "<p class='mb-[10px]'>Le visuel affiché correspond à l'aperçu généré lors de la publication. Ce statut indique que votre app a été mise en ligne pour la première fois.</p><p>Il n'est pas mis à jour automatiquement : les mises à jour, vérifications ou alertes doivent être suivies depuis votre compte développeur Google.</p>",
    "title": "Votre application est disponible sur le Google Play Store."
  },
  "app-update-available": {
    "cta": "Mettre à jour",
    "description": "Profitez des dernières nouveautés de l'application",
    "title": "Mise à jour disponible"
  },
  "app-update-modal": {
    "desc": "Pour mettre à jour votre application, vous devrez générer la nouvelle version et suivre le tutoriel de mise à jour.",
    "title": "Mise à jour de votre application"
  },
  "assets": {
    "app-logo": "Logo de l'app",
    "app-logo-explained": "Cette image correspond au logo de votre application.",
    "app-logo-size": "Taille recommandée : 2500px x 2500px",
    "app-name": "Nom de votre application radio",
    "apple-only": "Uniquement sur Apple",
    "change-image": "Remplacer l'image",
    "constraints-icon-smartphone": "Taille recommandée : 1024 x 1024px",
    "constraints-icon-tv": "Taille recommandée : 1280 x 768px",
    "constraints-smartphone": "Taille recommandée : 1242 x 2208px",
    "constraints-smartphone-long": "Taille recommandée : 1242 x 2688px",
    "constraints-topshelf-tv": "Taille recommandée : 4640 x 1440px",
    "constraints-tv": "Taille recommandée : 3840 x 2160px",
    "crop-image": "Recadrer l'image",
    "icon-tv": "Icône pour application TV",
    "icon-tv-description": "Cette icône s'affiche sur la page d'accueil des applications TV.",
    "images-title": "Visuels et Logos",
    "large-screen": "Grand écran",
    "logo": "Icône de l'application",
    "logo-description": "Cette image représente l'icône que l'utilisateur clique pour lancer l'application.",
    "next-step": "Étape suivante",
    "restrictions": "Restrictions techniques",
    "restrictions-icon-tv": "Doit inclure le nom complet de l'application, sans texte coupé, ni mention de fréquence FM, sauf si présente dans le nom",
    "restrictions-splashscreen-tv": "Ni l'image, ni le texte ne doit être coupée",
    "smartphone": "Smartphone",
    "smartphone-description": "Cette image correspond à l'affichage au lancement de l'application.",
    "smartphone-long-description": "Cette image correspond à l'affichage au lancement de l'application sur les grands téléphones.",
    "splashscreens": "Écrans de démarrage",
    "splashscreens-explained": "Cette image correspond à l'affichage au lancement de l'application sur les différents supports (téléphone, télévision).",
    "splashscreens-size": "Taille recommandée : 2500px x 2500px",
    "topshelf-tv-description": "Image affichée en preview de l'application dans l'interface Apple TV.",
    "topshelf-tv-short": "Bannière TV",
    "tv": "Écran TV",
    "tv-description": "Cette image s'affiche au lancement de l'application sur télévision.",
    "update-image-title": "Écrans et logos"
  },
  "audio-dedications": {
    "choose-radio": "Choisir une radio",
    "end": "Fin",
    "end-placeholder": "Merci pour votre dédicace !",
    "need-a-rk-radio": "Cette page nécessite un flux RadioKing pour fonctionner.",
    "radio": "Radio",
    "rk-create-radio-cta": "Créer ma radio",
    "rk-radio-create-link": "/creer-radio",
    "text": "Texte",
    "welcome": "Bienvenue",
    "welcome-placeholder": "Envoyez votre dédicace à l'antenne !"
  },
  "changelog": {
    "fixes": "Correctifs",
    "improvement": "Améliorations",
    "new": "Nouveautés",
    "read-more": "Voir plus",
    "title": "Changelog"
  },
  "color-selector": {
    "hex-error": "Le code couleur n'est pas correct.",
    "opacity": "Opacité",
    "opacity-error": "L'opacité doit être comprise entre 0 et 100"
  },
  "config-submenu": {
    "content": "Contenu",
    "design": "Design"
  },
  "create-app-form": {
    "change-image": "Changer l'image",
    "choose-name": "Choisir le nom de l'application",
    "choose-name-explained": "Choisissez un nom unique pour votre application mobile. Vous pourrez toujours le modifier plus tard si nécessaire.",
    "max-length": "La longueur maximale est de 30 caractères.",
    "min-length": "La longueur minimale est de 2 caractères.",
    "missing-name": "Le nom est requis.",
    "name-placeholder": "Nom de votre application",
    "no-emojis": "Les emojis ne sont pas autorisés.",
    "no-spaces-only": "Le nom ne peut pas être uniquement composé d'espaces.",
    "start": "Commencer",
    "unavailable-name": "Ce nom d'application est déjà pris"
  },
  "dashboard": {
    "consumption": "Consommation des notifications",
    "hello": "Bonjour",
    "new-subscribers": "Nouveaux inscrits des 7 derniers jours",
    "new-subscribers-unit": "{count, plural, =1 {Nouvel inscrit} other {Nouveaux inscrits}}",
    "notifications-sent": "Notifications envoyées",
    "notifications-sent-unit": "{count, plural, =1 {Notification} other {Notifications}}",
    "subscriber-detail": "Répartitions des utilisateurs",
    "subscribers-total": "Inscrits aux notifications",
    "title": "Statistiques de notifications",
    "welcome": "Bienvenue sur votre tableau de bord."
  },
  "general-configuration": {
    "app-langugage": "Langue de l'application",
    "background-color": "Couleur 1",
    "background-color-2": "Couleur 2",
    "background-color-style": "Style",
    "background-gradient-direction": "Direction",
    "bicolor-color-tooltip": "Bicolore",
    "blur": "Flou",
    "blur-details": "Le flou d'arrière plan permet d'ajouter un effet visuel à votre image pour mettre en valeur le contenu principal.",
    "body-size": "Taille du corps",
    "button-color": "Couleur des boutons",
    "button-label": "Bouton",
    "button-type": "Type de bouton",
    "color": "Couleur",
    "cover": "Pochette",
    "cover-background-details": "La pochette du titre en cours s'affichera en tant qu'image d'arrière plan.",
    "default-background-image": "Image par défaut",
    "font-size": "Taille du texte",
    "gradient-color-tooltip": "Dégradé",
    "header": "Entête",
    "header-text-color": "Couleur du texte",
    "icons": "Icônes",
    "image": "Image",
    "invert-colors": "Inverser les couleurs",
    "long-background-image": "Image longue",
    "rounded-borders": "Coins arrondis",
    "shodow-box": "Ombres",
    "show-logo": "Afficher le logo",
    "solid-color-tooltip": "Uni",
    "styles": "Styles",
    "styles-background": "Arrière Plan",
    "text-align": "Alignement du texte",
    "typography": "Typographie"
  },
  "global": {
    "cancel": "Annuler",
    "share": "Partager",
    "url-copied": "L'URL a été copiée avec succès dans le presse-papiers.",
    "url-copy-failed": "Impossible de copier l'URL dans le presse-papiers. Veuillez réessayer.",
    "url-invalid": "L'URL est incorrecte",
    "validate": "Valider"
  },
  "header": {
    "help-link": "https://help.radioking.com/hc/fr/categories/4408651163665-Mobile-application"
  },
  "html-config": {
    "background": "Arrière plan du bloc HTML",
    "code-placeholder": "Saissez votre code HTML",
    "content": "Contenu de la page"
  },
  "icon-search": {
    "icon-name": "Nom de l'icône"
  },
  "icon-type-selector": {
    "regular": "Contour",
    "solid": "Plein"
  },
  "image-cropper": {
    "cancel": "Annuler",
    "iconTv": "Changer l'icône de l'application TV",
    "logo": "Changer l'image de l'icône de l'application",
    "recommended": "Taille recommandée",
    "replace": "Changer l'image",
    "restrictions": "Restrictions techniques",
    "rotation": "Rotation",
    "save": "Enregistrer",
    "splashscreen": "Changer l'image de l'écran de démarrage",
    "splashscreenLarge": "Changer l'image du grand écran de démarrage",
    "splashscreenTv": "Changer l'image de l'écran TV",
    "topShelfTv": "Changer l'image de la bannière TV",
    "zoom": "Zoom"
  },
  "image-input": {
    "cancel": "Annuler",
    "dragging-over-text": "Lâchez votre image pour la charger",
    "load": "charger",
    "main-text": "Glisser-déposer \nou"
  },
  "image-size-guide": {
    "size": "Taille recommandée: \n{width} x {height}px\nPoids maximum : 10 Mo"
  },
  "image-upload": {
    "alt": "Image importée",
    "change-image": "Changer l'image",
    "constraints-title": "Restrictions techniques",
    "delete": "Supprimer",
    "file-size-error": "Le fichier doit peser moins de 10Mo",
    "file-type-error": "Formats acceptés : .jpg, .jpeg, .png"
  },
  "ios-publishing-empty-state": {
    "cta": "Passer à l'offre supérieure",
    "desc": "Vos auditeurs sont aussi sur iPhone. Ajoutez l'option iOS et offrez-leur une expérience complète, directement depuis l'App Store.",
    "title": "Votre application sur iOS"
  },
  "ios-screenshot": {
    "desc": "<p class='mb-[10px]'>Le visuel affiché correspond à l'aperçu généré lors de la publication. Ce statut indique que votre app a été mise en ligne pour la première fois.</p><p>Il n'est pas mis à jour automatiquement : les mises à jour, vérifications ou alertes doivent être suivies depuis votre compte développeur Apple.</p>",
    "title": "Votre application est désormais disponible sur Apple Store."
  },
  "login": {
    "login-button": "Connexion"
  },
  "margin-settings": {
    "no-margin": "Sans marges",
    "with-margin": "Avec marges"
  },
  "menu-content": {
    "title-error": "Le nom de la page doit contenir au minimum deux caractères"
  },
  "menu-design": {
    "background": "Arrière plan",
    "show-logo": "Afficher le logo",
    "styles": "Styles",
    "text-color": "Couleur du texte"
  },
  "menu": {
    "configuration": "Configuration",
    "content": "Design et contenu",
    "dashboard": "Tableau de bord",
    "notifications": "Notifications",
    "pages": "Les pages",
    "publication": "Publication",
    "publishing": "Publication",
    "settings": "Paramètres"
  },
  "mobile-access-warning": {
    "cta": "Accéder à la version ordinateur",
    "description": "Le simulateur n'est pas disponible sur mobile, mais vous pouvez y accéder via la version ordinateur.",
    "description-app-manager": "Le manager des apps n'est pas disponible sur mobile, mais vous pouvez y accéder via la version ordinateur.",
    "title": "Accéder à la version ordinateur"
  },
  "mock-tabs": {
    "alarm": "Réveil",
    "dedications": "Dédicaces",
    "podcast": "Podcast",
    "podcast-link": "https://feed.ausha.co/b3ZpnFJKZxdp",
    "rss": "RSS",
    "rss-link": "https://fr.radioking.com/blog/feed",
    "rss-news": "Actualités",
    "rss-podcasts": "Podcast",
    "rss-video": "Vidéo",
    "shout-outs": "Dédicaces audio",
    "song-history": "Historique des titres",
    "video-link": "https://www.youtube.com/feeds/videos.xml?channel_id=UCTwoQ5tlV-HoYe-VRNb-Hbw",
    "website": "Site Web"
  },
  "monetization": {
    "ad-unit-id": "ID de bloc d'annonces",
    "admob-configuration-tutorial": "Comment bien configurer AdMob ?",
    "admob-configuration-tutorial-url": "https://help.radioking.com/hc/fr/articles/4410223563025",
    "admob-get-id-tutorial": "Comment obtenir vos identifiants AdMob ?",
    "admob-get-id-tutorial-url": "https://help.radioking.com/hc/fr/articles/4410238783377",
    "and": "et",
    "android-app-id": "ID d'application Android",
    "banner": "Bannière",
    "banner-description": "Publicité qui s’affiche sur la page Player de l’application.",
    "change-offer-text": "Passez à l’offre supérieure pour activer la monétisation. Une solution simple pour commencer à générer des revenus avec votre application.",
    "configure-later": "Vous pouvez configurer la monétisation dès maintenant ou l’activer ultérieurement.",
    "description-1": "Google AdMob vous permet de monétiser votre application en affichant de la publicité.",
    "description-2": "Pour configurer Admob, rendez vous sur le site AdMob",
    "interstitial": "Interstitiel",
    "interstitial-description": "Publicité qui s’affiche lors de l’ouverture de l’application.",
    "ios-app-id": "ID d'application iOS",
    "next-step": "Étape suivante",
    "option-toggle": "Activer les publicités",
    "our-tutorials": "sur nos tutoriels",
    "title": "Monétisation"
  },
  "new-stream": {
    "name": "Ma Radio"
  },
  "notification-congrats-dialog": {
    "button": "Commencer",
    "desc": "Prenez le contrôle de votre application mobile en toute simplicité ! Personnalisez-la, envoyez des notifications et suivez vos performances directement depuis votre tableau de bord.",
    "title": "Félicitations pour la configuration de votre application !"
  },
  "notification-dashboard": {
    "empty-state": {
      "desc": "Votre application vient d'être publiée. Vos premiers résultats apparaîtront sur ce tableau de bord d'ici peu.",
      "title": "Vous n’avez pas encore de statistiques",
      "tutorial": {
        "card1": {
          "desc": "Apprenez à envoyer, cibler et analyser vos notifications push pour engager vos auditeurs efficacement.",
          "title": "Tout savoir sur les Notifications Push",
          "url": "https://help.radioking.com/hc/fr/articles/4410238827409"
        },
        "card2": {
          "desc": "Découvrez comment configurer, mettre à jour et publier votre application mobile en toute simplicité.",
          "title": "Tout savoir sur l’Application Mobile",
          "url": "https://help.radioking.com/hc/fr/categories/4408651163665"
        },
        "learn-more": "En savoir plus",
        "title": "Laissez-nous vous guider"
      }
    },
    "send": "Envoyer une notification",
    "title": "Notifications",
    "total": "{count, plural, =0 {Envoyez votre première notification} =1 {Vous avez envoyé une notification} other {Vous avez envoyé # notifications}}"
  },
  "notification-form": {
    "cancel": "Annuler",
    "close-confirmation-button": "Oui, quitter",
    "close-confirmation-message": "Êtes-vous certain de vouloir quitter la création de votre notification ?",
    "close-confirmation-message-details": "Fermer la fenêtre actuelle entraînera la perte des modifications en cours. Êtes-vous sûr de vouloir quitter sans enregistrer ?",
    "close-confirmation-tooltip": "Une erreur s'est glissée dans la rédaction de votre notification. Pour l'enregistrer, merci de vérifier le formulaire.",
    "date-placeholder": "Choisissez un jour",
    "deeplink": "Redirection",
    "deeplink-desc": "Au clic sur la notification, l'auditeur sera redirigé vers la page sélectionnée.",
    "deeplink-placeholder": "Sélectionner une page",
    "draft": "Enregistrer le brouillon",
    "episode-placeholder": "Sélectionner un épisode",
    "episode-selection": "Épisode (optionnel)",
    "language": "Langue",
    "language-placeholder": "Choisissez votre/vos langues",
    "location": "Localisation",
    "location-placeholder": "Pays, ville, région, ...",
    "location-search": "Envoyer une notification géolocalisée",
    "message": "Message",
    "message-error": "Le message doit contenir entre 3 et 140 caractères.",
    "message-placeholder": "Écrivez votre message",
    "new": "Nouvelle notification",
    "os": "Système d'exploitation",
    "platform-error": "Choisissez au moins un système d'exploitation",
    "podcast-placeholder": "Sélectionner un podcast",
    "podcast-selection": "Titre du podcast (optionnel)",
    "radio-placeholder": "Sélectionner une radio",
    "radio-selection": "Radio",
    "schedule": "Planifier",
    "send": "Envoyer",
    "time-placeholder": "Heure",
    "title": "Titre",
    "title-error": "Le titre (optionnel) doit contenir entre 3 et 50 caractères.",
    "title-placeholder": "Titre de votre notification",
    "tooltip-support-ios": "Pour envoyer vos notifications sur iOS, passez à l'abonnement supérieur.",
    "tooltip-unavailable-android": "Les notifications ne sont pas encore disponibles pour votre application Android.",
    "tooltip-unavailable-ios": "Les notifications ne sont pas encore disponibles pour votre application iOS."
  },
  "notification-sidebar": {
    "empty-state": {
      "desc": "Après le premier envoi, votre historique de notifications sera disponible",
      "title": "Envoyez votre première notification"
    },
    "scheduled": "Planifié"
  },
  "notification-table": {
    "android": "Envoi sur Android",
    "date": "Date d'envoi",
    "draft": "Brouillon",
    "empty-state-desc": "Faites connaitre à vos auditeurs les nouveautés de votre radio, les événements, et bien plus encore.",
    "ios": "Envoi sur iOS",
    "message": "Message",
    "not-sent-android": "Cette notification n'a pas été envoyée sur Android",
    "not-sent-ios": "Cette notification n'a pas été envoyée sur iOS",
    "reach": "Total d'envois"
  },
  "notification-targeted-subscribers": {
    "android": "sur Android",
    "ios": "sur iOS",
    "total": "Envois estimés"
  },
  "onboarding-modal": {
    "content-design": {
      "button": "Continuer l'édition",
      "desc": "Utilisez les onglets pour basculer entre l'édition du contenu et la personnalisation du design de la page sélectionnée.",
      "title": "Contenu et design"
    },
    "general-configuration": {
      "desc": "Personnalisez les paramètres de thème de votre application mobile pour qu'elle corresponde à vos besoins spécifiques.",
      "title": "Configuration du thème"
    },
    "interface": {
      "button": "Terminer",
      "desc": "Personnalisez les éléments visuels de votre application. Ajustez la langue, les couleurs, la typographie et les icônes pour créer une expérience utilisateur unique",
      "title": "Personnalisation de l'interface"
    },
    "menu": {
      "desc": "Organisez et personnalisez le menu de votre application mobile pour une navigation optimale de vos auditeurs.",
      "title": "Gestion du menu"
    },
    "next": "Suivant",
    "pages": {
      "desc": "Créez, modifiez et organisez les pages de votre application mobile.",
      "title": "Gestion des pages"
    },
    "previous": "Précédent",
    "stepper": {
      "button": "Passer à la prochaine étape",
      "desc": "Visualisez votre avancement à chaque étape de la création de votre projet. Cliquez sur \"Prochaine étape\" pour continuer.",
      "title": "Suivez votre progression"
    }
  },
  "other-config": {
    "need-a-rk-website": "⚠️ Cette page nécessite un Site Radio RadioKing pour fonctionner.",
    "rk-website-create-link": "/creer-site-cms-radio",
    "rk-website-cta": "Créer mon Site Radio",
    "rk-website-link": "Lien de votre site radio",
    "rss-link": "Lien du flux RSS",
    "website-link": "Lien du site internet",
    "what-is-rss": "Un <strong>flux RSS</strong> est un lien web qui se met automatiquement à jour avec votre contenu le plus récent.<br/>Si vous ne savez pas où trouver votre flux RSS, consultez votre plateforme de contenu ou service d'hébergement; il est généralement étiqueté comme 'Flux RSS' ou 'URL du flux'."
  },
  "page-config": {
    "background-color": "Couleur de l'arrière plan",
    "header-text-color": "Couleur de l'en-tête",
    "icon-and-name": "Icône et nom de la page"
  },
  "paid-publication-modal": {
    "buy": "Ajouter au panier",
    "buy-android": "Publier sur Android",
    "buy-ios": "Publier sur iOS",
    "cancel": "Annuler",
    "message": "Pour { price } par plateforme, RadioKing s'occupe de publier votre application sur vos comptes développeur Apple ou Google, en conformité avec les exigences des stores. <a target='_blank' href='https://fr.radioking.com/publication-app' class='underline text-brand'>Découvrez les étapes qui seront réalisées en détails.</a>",
    "title": "Publication par RadioKing"
  },
  "plan": {
    "all-basic": "Toutes les fonctionnalités de l'offre Basic ",
    "all-smart": "Toutes les fonctionnalités de l'offre Smart ",
    "android": "App native <b>Android</b>",
    "android-and-ios": "App native <b>Android & iPhone</b>",
    "android-tablet": "Compatible avec <b>tablette Android</b>",
    "annual": "Annuel",
    "apple-watch": "<b>Apple Watch</b>",
    "auto": "<b>Android Auto & Apple CarPlay</b>",
    "carplay-tooltip": "Sous réserve d'acceptation d'Apple (délai de 1 à 3 semaines) pour Carplay",
    "choose": "Choisir cette offre",
    "customizable": "Design 100% personnalisable",
    "monetization": "Monétisation",
    "monetization-tooltip": "Régie publicitaire : AdMob",
    "monthly": "Mensuel",
    "multi-language": "Multi-langues",
    "multi-language-tooltip": "Choisissez entre 6 langues différentes lors de la création de l'App : FR, EN, ES, DE, IT, PT",
    "multi-stream": "Multi-flux Radio",
    "multi-stream-tooltip": "Compatibilité avec flux Shoutcast, Icecast & autres fournisseurs",
    "per-month": "/mois",
    "per-year": "/an",
    "pick-title": "Choisir mon offre",
    "plus": "plus",
    "publication-tooltip": "Valable pour 1 publication uniquement",
    "push": "<b>{number}</b> notifications push",
    "push-tooltip": "<b>Notifications supplémentaires :</b></br>100 000 : +5{currency}/mois</br>300 000 : +15{currency}/mois</br>500 000 : +25{currency}/mois</br>750 000 : +35{currency}/mois",
    "recommended": "Offre recommandée",
    "rk-published": "Publication de l'app par RadioKing <b>INCLUSE</b>",
    "subtitle": "Choisissez l'offre dont vous et votre team avez besoin.",
    "tablet": "Compatible <b>iPad & tablette Android</b>",
    "tv": "<b>Android TV & Apple TV</b>",
    "two-months-free": "2 mois offerts",
    "unlimited-downloads": "Téléchargement de l'App <b>ILLIMITÉ</b>",
    "unlimited-tabs": "Onglets <b>ILLIMITÉS</b>",
    "user-published": "Publication de l'app par RadioKing (option)",
    "user-published-tooltip": "50{currency} par publication d'App",
    "white-label": "Marque blanche",
    "white-label-tooltip": "La Marque Blanche permet de ne pas avoir de mention 'RadioKing' à l'intérieur de votre application."
  },
  "player-buttons": {
    "apple": "Acheter via Apple Music",
    "apple-afiliate-help-link": "https://help.radioking.com/hc/fr/articles/4409541483665-API-externes-Obtenir-son-code-d-affiliation-Apple-Partner-anciennement-iTunes",
    "apple-music-placeholder": "Votre identifiant Apple Music Affiliate",
    "auto-play": "Auto play",
    "email": "Email",
    "email-error": "L'email n'est pas correct",
    "infobox-itunes": "💡 Le bouton 'Acheter sur Apple Music' permet à vos auditeurs d'acheter le titre en cours. C'est un excellent moyen de monétiser votre application.<br/><br/>Pour en profiter, vous devez vous inscrire au programme d'affiliation d'Apple.",
    "infobox-itunes-cta": "En savoir plus",
    "mail-placeholder": "contact@ma-radio.com",
    "other-actions": "Autres actions",
    "phone": "Appel",
    "phone-error": "Le numéro n'est pas correct",
    "phone-placeholder": "+33 6 78 89 90 89",
    "share": "Partage",
    "sleep-timer": "Minuteur de veille",
    "sms": "SMS",
    "sms-placeholder": "+33 7 33 67 89 07",
    "title": "Boutons",
    "vote": "Vote",
    "vote-explained": "Les votes permettent à vos auditeurs de vous dire quand ils aiment votre musique. Cette fonctionnalité n'est disponible que pour les radios hébergées par RadioKing."
  },
  "player-content": {
    "icon-and-name": "Icône et nom de la page",
    "stream": "Flux de la radio"
  },
  "player-design": {
    "always-show-default-cover": "Toujours afficher la pochette par défaut",
    "artist-color": "Couleur de l'artiste",
    "constraints-body": "Taille recommandée : 440 x 440px\nPoids maximum : 10 Mo\nFormats acceptés : .jpg, .jpeg, .png",
    "cover": "Pochette par défaut",
    "cover-border-color": "Couleur de la bordure de pochette",
    "cover-explained": "La pochette par défaut est l’image qui remplace la photo du titre en cours si celui-ci n’en possède pas.",
    "cover-shape": "Forme de la pochette",
    "cover-type": "Style de pochette",
    "show-cover-border": "Afficher la bordure de la pochette",
    "title-and-artist": "Titre et artiste",
    "title-color": "Couleur du titre",
    "titling-background": "Arrière plan"
  },
  "privacy": {
    "description": "Configurez les paramètres de votre plateforme de gestion du consentement (CMP) pour la conformité RGPD.",
    "didomi-api-key": "Clé API Didomi",
    "didomi-api-key-placeholder": "Saisissez votre clé API Didomi",
    "didomi-notice-id": "ID de la notice Didomi",
    "didomi-notice-id-placeholder": "Saisissez votre ID de notice Didomi",
    "option-toggle": "Activer Didomi CMP",
    "privacy-policy-url": "URL de la politique de confidentialité",
    "privacy-policy-url-placeholder": "https://exemple.com/confidentialite",
    "terms-of-service-url": "URL des conditions d'utilisation",
    "terms-of-service-url-placeholder": "https://exemple.com/conditions",
    "title": "Confidentialité"
  },
  "podcast-config": {
    "add": "Ajouter un podcast",
    "duplicate": "L'url saisie existe déjà dans la liste",
    "episodes": "épisodes",
    "feed-link": "Source du podcast",
    "invalid": "L'url saisie n'est pas un flux RSS de podcast"
  },
  "publication-addon-dialog": {
    "accept": "Radioking publie pour moi",
    "message": "Nous nous chargeons entièrement de la publication de votre application sur vos comptes développeur Apple et Google. Confiez-nous cette tâche, et assurez-vous que votre app soit en ligne rapidement, conformément aux exigences des plateformes.<br/><br/>Cette option ne coûte que { price } en une fois.<br/><br/>Si vous souhaitez publier par vous-même, nos tutoriels vous guideront pas-à-pas.",
    "refuse": "Je publie moi-même",
    "title": "Souhaitez-vous que RadioKing publie l'application pour vous ?"
  },
  "publishing-banner": {
    "cta": "Publier",
    "description": "Pour 50€ par plateforme, RadioKing s'occupe de publier votre application sur vos comptes développeur Apple ou Google, en conformité avec les exigences des stores. ",
    "link": "https://fr.radioking.com/publication-app",
    "link-description": "En savoir plus sur la publication par RadioKing.",
    "title": "RadioKing publie pour moi"
  },
  "publishing-step": {
    "android-dev-account-cta": "Créer mon compte",
    "android-dev-account-description": "La création et la validation de votre compte développeur Google est nécessaire pour publier votre application. Pour en savoir plus, consultez notre tutoriel.",
    "android-dev-account-label": "Créer mon compte Play Store",
    "android-tutorial-description": "Suivez le tutoriel pour soumettre votre application à Google et la publier sur le Play Store.",
    "android-tutorial-label": "Uploader l'application sur le Play Store",
    "download-cta": "Télécharger mon application",
    "download-description": "Téléchargez l'archive de votre application. Cette archive est nécessaire pour la publication sur les stores.",
    "download-label": "Télécharger l'application",
    "existing-dev-account": "J'ai déjà un compte",
    "generation-cta": "Lancer la génération",
    "generation-description": "Cette étape lance le processus automatique de création de votre application à partir des éléments que vous avez fournis (nom, icône, contenu, etc.). Une fois la génération terminée, vous pourrez télécharger les fichiers requis pour la publication.",
    "generation-label": "Générer l'application",
    "in-progress": "En cours",
    "ios-carplay-cta": "Faire la demande",
    "ios-carplay-description": "Soumettez une demande d'autorisation CarPlay auprès d'Apple. Cette étape est nécessaire pour permettre l'utilisation de votre application dans les véhicules compatibles CarPlay. L'approbation peut prendre de 1 à 3 semaines.",
    "ios-carplay-label": "Demander l'autorisation CarPlay",
    "ios-dev-account-cta": "Créer mon compte",
    "ios-dev-account-description": "La création et la validation de votre compte développeur Apple est nécessaire pour publier votre application. Pour en savoir plus, consultez notre tutoriel.",
    "ios-dev-account-label": "Créer mon compte App Store",
    "ios-tutorial-description": "Suivez le tutoriel pour soumettre votre application à Apple et la publier sur l'App Store.",
    "ios-tutorial-label": "Uploader votre application sur App Store",
    "published-label": "Félicitations, votre application est en ligne !",
    "tutorial-cta": "Commencer la publication"
  },
  "publishing": {
    "app-swap": "Changer d'application",
    "subtitle": "Publiez votre application étape par étape et consultez son état de publication",
    "title": "État de publication"
  },
  "setting-confirmation-modal": {
    "cancel": "Annuler",
    "description": "Pour que les modifications de vos paramètres soient visibles par vos utilisateurs, il sera nécessaire de republier votre application.",
    "documentation": "documentation",
    "link": "https://help.radioking.com/hc/fr/articles/26106170721041",
    "link-description": "Vous trouverez plus d'information dans notre ",
    "save": "Enregistrer sans publier",
    "save-redirect": "Enregistrer et publier",
    "title": "Publier les modifications"
  },
  "settings-list": {
    "general-configuration": "Configuration du thème",
    "menu": "Menu",
    "pages": "Les pages"
  },
  "simulator-preview": {
    "add-image-text": "Chargez une image pour voir l'aperçu",
    "add-image-title": "Ajoutez votre Image"
  },
  "song-history-config": {
    "api-url": "Lien d'API",
    "api-url-description": "API donnant l'historique des derniers titres.",
    "search-api-url": "Lien d'API de recherche",
    "search-api-url-description": "API permettant la recherche de titres dans l'historique."
  },
  "stepper": {
    "design": "Design et contenu",
    "images": "Visuels",
    "last": "À vous de jouer",
    "monetization": "Monétisation",
    "name": "Nom",
    "next": "Prochaine étape",
    "plan": "Offre",
    "previous": "Étape précédente",
    "save": "Enregistrer"
  },
  "stream-list": {
    "search-placeholder": "Rechercher un flux",
    "empty-search-title": "Aucun flux trouvé",
    "empty-search-description": "Essayez un autre mot-clé.",
    "sort-confirm-title": "Trier par ordre alphabétique ?",
    "sort-confirm-message": "L'ordre actuel de vos flux sera remplacé par un tri alphabétique.",
    "sort-confirm-button": "Trier",
    "cancel": "Annuler"
  },
  "stream-list-item": {
    "edit": "Editer",
    "move-to-top": "Envoyer tout en haut",
    "move-to-bottom": "Envoyer tout en bas",
    "delete": "Supprimer",
    "delete-confirm-title": "Supprimer ce flux ?",
    "delete-confirm-message": "Êtes-vous sûr de vouloir supprimer ce flux ? Cette action est irréversible.",
    "delete-confirm-button": "Supprimer",
    "cancel": "Annuler"
  },
  "stream-edit": {
    "choose-mountpoint": "Choisissez votre point de montage",
    "choose-radio": "Choisissez votre radio",
    "logo": "Logo du flux",
    "mount-point": "Point de montage",
    "name": "Nom du flux",
    "other": "MP3 / AAC",
    "radio": "Radio",
    "radioking-no-radios-error": "Vous devez posséder un flux RadioKing pour choisir cette option",
    "stream-type": "Type de flux",
    "stream-url": "Url du flux",
    "title-url": "Url du titrage",
    "title-url-infobox": "💡 Veuillez saisir une URL de page web qui affiche uniquement : 'Artiste - Titre de la chanson'",
    "url-hls-not-allowed": "Seuls les flux HLS peuvent utiliser une URL en .m3u8",
    "url-required": "Une URL est requise"
  },
  "stream-modal": {
    "title-add": "Ajouter un flux",
    "title-edit": "Modifier le flux",
    "name-placeholder": "Nom du flux",
    "type-placeholder": "Sélectionnez un type",
    "title-url-description": "Partagez l'URL d'une page qui contient simplement : 'Artiste - Titre de la chanson'",
    "cancel": "Annuler",
    "confirm-close": "Fermer la fenêtre actuelle entraînera la perte des modifications en cours. Êtes-vous sûr de vouloir quitter sans enregistrer ?",
    "add": "Ajouter",
    "save": "Enregistrer",
    "duplicate-url": "Ce flux est déjà utilisé par {name}"
  },
  "toast": {
    "generic-error": "Une erreur est survenue. Veuillez réessayer plus tard",
    "generic-fetch-error": "Une erreur est survenue. Veuillez réessayer plus tard",
    "login_error": "Le mot de passe et/ou le nom d'utilisateur est erroné",
    "notification-deleted": "Votre notification a été supprimée",
    "notification-draft": "Votre brouillon a été sauvegardé",
    "notification-frequency-error": "Vous devez espacer l'envoi de vos notifications d'au moins 5 minutes.",
    "notification-quota-error": "Votre quota est dépassé, vous avez envoyé trop de notifications push.",
    "notification-scheduled": "Notification planifiée",
    "notification-sent": "Notification envoyée",
    "notification-updated": "Notification mise à jour",
    "post-config-success": "Vos modifications ont bien été enregistrées."
  },
  "tutorial-modal": {
    "close": "Consulter plus tard",
    "validate": "J'ai terminé"
  },
  "unsaved-changes-dialog": {
    "cancel": "Annuler",
    "close-confirmation-button": "Fermer sans enregistrer",
    "close-confirmation-message": "Fermer sans enregistrer",
    "close-confirmation-message-details": "Souhaitez-vous fermer sans enregistrer les modifications ?"
  },
  "update-content": {
    "save": "Enregistrer",
    "subtitle": "Modifiez le design et le contenu de votre application.",
    "title": "Design et contenu"
  },
  "update-settings": {
    "nav": {
      "logos": "Écrans et logos",
      "monetization": "Monétisation",
      "name": "Nom",
      "privacy": "Confidentialité"
    },
    "save": "Enregistrer et publier",
    "subtitle": "Modifiez les paramètres de votre application.",
    "title": "Paramètres"
  },
  "update_toast": {
    "update-available": "Une mise à jour est disponible.",
    "update-now": "Mettre à jour"
  },
  "upgrade-offer": {
    "button": "Passer à l'offre supérieure",
    "description": "Informez vos auditeurs en temps réel grâce à des notifications personnalisées et ultra-précises (filtrées par pays, langue, plateforme, et plus encore). Profitez-en pour booster votre visibilité !",
    "image": "/assets/smartphone-notif-example-fr.png",
    "title": "Maximisez l'engagement de vos auditeurs avec des notifications ciblées"
  },
  "user-menu": {
    "customer": "Espace client",
    "help": "Centre d'aide",
    "logout": "Se déconnecter",
    "news": "Nouveautés",
    "news-link": "https://headwayapp.co/radioking-changelog"
  },
  "welcome-animation": {
    "message": "Merci d'avoir choisi RadioKing pour votre application mobile !\nNous allons vous guider depuis l'édition jusqu'à la publication sur les stores.",
    "welcome": "Bienvenue"
  }
}
